import { Department } from "../../department";
import { HisInformationListItem } from "../HisInformationListItem";
import { User } from "../../user";

export interface IHisInformationGroupSource {
  data: any;
}

/**
 * グループ連動入力で医療機関_医師名・作成者・医師選択の選択時に、
 * 診療科名称・診療科選択が設定されるため、ユーザの診療科を保持する。
 */
export class HisInformationUserGroupSource implements IHisInformationGroupSource {

  constructor(public data: User[], public department: Department) {}
}

export class HisInformationDepartmentGroupSource implements IHisInformationGroupSource {
  constructor(public data: Department[]) {}
}

/**
 * 病名・入院・手術情報のそれぞれの項目のキーと日付書式を保持する。
 * 日付書式は選択画面の日付書式が値を設定するとき、適用されるされるため保持。
 */
export class HisInformationListItemGroupSource implements IHisInformationGroupSource {
  constructor(public data: HisInformationListItem[], public dateFormat: string) {}
}
